import React, { useState } from 'react';
import { Paper, Container, Grid, Box, CssBaseline, Button, Typography, TextField, InputAdornment, Slide } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useBackdrop, openBackdrop } from '../hooks/useBackdrop';
import { useNavigate } from 'react-router-dom';
import Loading from './Loading';




export default function Search() {


    const [search, setSearch] = useState('L');
    const navigate = useNavigate();
    const { openBackdrop, closeBackdrop } = useBackdrop();

    const onSearch = () => {
        openBackdrop(
            <div>
                <Loading />
            </div>
        );
        setTimeout(() => {
            closeBackdrop();
            navigate(`/load/${search}`);

        }, 1000);


    }


    return (
        <Box sx={{ padding: '15px', height: 'calc(100vh - 130px)' }}>
            <Grid container spacing={2} flexDirection="column" alignContent="center">
                <Grid item xs={12}>
                    <Typography variant="h6">Enter Load Number</Typography>
                </Grid>

                <Grid item xs={12}>
                    <Paper>
                        <TextField
                            fullWidth
                            value={search}
                            onChange={(event) => setSearch(event.target.value)}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Paper>
                </Grid>

                <Grid item xs={12}>
                    <Button fullWidth disabled={search.length < 2} variant="contained" onClick={onSearch}>Search </Button>
                </Grid>

            </Grid>


        </Box>
    );
}

// display: 'flex', flexDirection: 'column', justifyContent: 'flex-start'